import React, { Fragment } from 'react'
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const AdvanceTableHeader = () => {
    const styles = StyleSheet.create({
        Flightcontainer: {
            flexDirection: 'row',
            backgroundColor: '#E4E4E4',
            alignItems : 'center',
            fontStyle: 'bold',
            paddingBottom : '5px',
            paddingTop : '10px',
            paddingLeft : '15px'
        },
        one: {
            width : '15%',
            fontSize : "11px",
            color : "#333333"
        },
        two: {
            width : '20%',
            fontSize : "11px",
            color : "#333333"
        },
        three:{
            width : '20%',
            fontSize : "11px",
            color : "#333333"
        },
        four: {
            width : '25%',
            fontSize : "11px",
            color : "#333333"
        },
        five: {
            width : '20%',
            fontSize : "11px",
            color : "#333333"
        },
    });
    return (
        <Fragment>
            <View style={styles.Flightcontainer}>
                <Text style={styles.one}>Advance ID</Text>
                <Text style={styles.two}>Date - Time</Text>
                <Text style={styles.three}>Recorded By</Text>
                <Text style={styles.four}>Reference</Text>
                <Text style={styles.five}>Amount</Text>
            </View>
        </Fragment>
    )
}

export default AdvanceTableHeader;